<template>
    <div :class="showInCard ? 'card' : ''">
        <div v-if="isExpanded">
            <div :class="showInCard ? 'card-header' : ''">
                <button type="button" class="btn btn-link btn-primary m-0" @click="isExpanded = false">
                    <i class="fas fa-compress fa-2x"></i>
                </button>
                <span class="align-content-center font-weight-bold">{{ title }}</span>
            </div>
            <div :class="showInCard ? 'card-body' : ''">
                <slot name="content">
                    <h5>Here might be a content</h5>
                </slot>
            </div>
        </div>
        <div v-else :class="showInCard ? 'card-header' : ''">
            <button type="button" class="btn btn-link btn-primary m-0" @click="isExpanded = true">
                <i class="fas fa-expand fa-2x"></i>
            </button>
            <span class="align-content-center font-weight-bold">{{ title }}</span>
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            expanded: {
                type: Boolean,
                default: false
            },
            title: {
                type: String
            },
            showInCard: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                isExpanded: this.expanded,

            }
        },
        methods: {

        }
    }
</script>
